<template>
  <div class="app-file">
    <v-checkbox
      v-if="selectable"
      v-model="isSelected"
      class="mt-0 mr-2 pt-2"
      hide-details
      dense
    />
    <a
      class="mt-2"
      :href="!file.removed && file.url"
      target="_blank"
      :download="file.filename"
    >
      <img :src="formatIcon">
    </a>
    <div class="ml-3 overflow-hidden">
      <p
        class="text-subtitle-2"
        :class="{'red--text text--darken-4': file.removed}"
      >
        {{ file.filename }}
      </p>
      <p class="text-10">
        <template v-if="file.timestamp">
          <span v-if="file.currentStatus === 'brief'">Przy zgłoszeniu</span>
          <span v-else>
            {{ file.timestamp * 1000 | timestamp }}
          </span> /
        </template>{{ fileSizeFormatted }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import utils from '@/helpers/utils';

export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selectedFiles: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapState('filters', [
      'filtersOptions',
    ]),

    isSelected: {
      get() {
        return this.selectedFiles.includes(this.file.id);
      },
      set() {
        this.$emit('select', this.file.id);
      },
    },

    formatIcon() {
      const format = this.file.filename.substr(this.file.filename.lastIndexOf('.') + 1).toLowerCase();
      try {
        return require(`@/assets/img/file-icon_${format}.svg`);
        } catch (e) {
          return require(`@/assets/img/file-icon_other.svg`)
        }
    },

    fileSizeFormatted() {
      return utils.parseFileSize(this.file.size);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-file {
  display: flex;
  align-items: flex-start;
  text-align: left;
}
</style>
